import { Select, Typography } from 'antd';
import { IBestDataset } from '../../../../../types/analytics';
import { useDatasetCategories } from '../../hooks/shared/useDatasetCategories';
import styles from '../Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface DatasetSelectProps {
  id: string;
  datasets: IBestDataset[];
  value: string | null;
  onChange: (datasetId: string) => void;
  label?: string;
  disabled?: boolean;
}

export const DatasetSelect = ({
  id,
  datasets,
  value,
  onChange,
  label = 'Dataset',
  disabled = false,
}: DatasetSelectProps) => {
  const categories = useDatasetCategories(datasets);

  return (
    <div className={`${styles.formItem} ${styles.datasetItem}`}>
      <Text>{label}</Text>
      <Select
        id={id}
        value={value}
        onChange={onChange}
        placeholder='Select dataset'
        disabled={disabled}
      >
        {categories.map((category) => (
          <Select.OptGroup key={category} label={category}>
            {datasets
              .filter((item) => item.label === category)
              .map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.value}
                </Select.Option>
              ))}
          </Select.OptGroup>
        ))}
      </Select>
    </div>
  );
};
